import React, { useState, useEffect } from "react"
import { Redirect, useLocation, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Space, Popconfirm, Button, notification, Input } from "antd"
import { EyeOutlined, EditOutlined, DeleteOutlined, PlusOutlined, SearchOutlined, UploadOutlined, CheckCircleFilled, CloseCircleOutlined } from "@ant-design/icons"
import _ from "lodash"

/* custom component */
import Header from "../../../component/Header/Header"
import { PageContainer, Xtable, Xpagination, XtagTable } from "../../../component/Xcomponent"
import ContactUsView from "../ContactUsView/ContactUsView"

/* actions */
import { getContactUsEnquriesList, getContactUsEnquriesListReset } from "../../../action/getContactUsEnquriesListAction"




const ContactUslist = props => {
    /* variables */
    const {
        getContactUsEnquriesList, getContactUsEnquriesListReset, getContactUsEnquriesListState

    } = props
    const search = useLocation().search;
    const page = new URLSearchParams(search).get('page');
    const [redirect, setRedirect] = useState([false, ""])
    const [refresh, setRefresh] = useState(0)
    const [searchText, setSearchText] = useState({})
    const [pagination, setPagination] = useState({
        page: page ? page : 1,
        records: 25
    })
    const [tableData, setTableData] = useState([])
    const [view, setView] = useState({
        visible: false,
        id: null,
    })
    const getColumnSearchProps = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    });
    const columns = [

        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            ...getColumnSearchProps('name', 'Name')
        },
      
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
            width: 200,
            ...getColumnSearchProps('phone', 'Phone')
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 200,
            ...getColumnSearchProps('email', 'Email')
        },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'action',
            width: 200,
            render: (id, row) => (
                <Space size="small">
                    <Button size="small" shape="circle" icon={<EyeOutlined />} onClick={() => setView({ id: id, visible: true })} />
                   
                </Space>
            )
        },
    ];

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText({
            ...searchText,
            [dataIndex]: selectedKeys[0]
        })
    }
    const handleReset = (clearFilters, dataIndex) => {
        let remainSearch = _.omit(searchText, [dataIndex])
        clearFilters()
        setSearchText(remainSearch)
    }


    /* callbacks */
    useEffect(() => {
        return (() => {
            getContactUsEnquriesListReset()
        })
    }, [])

    useEffect(() => {
        getContactUsEnquriesList({
            page: pagination.page,
            records: pagination.records,
            ...searchText
        })
    }, [refresh, pagination, searchText])

    useEffect(() => {
        if ( getContactUsEnquriesListState.apiState === "success") {

            let tableData = []
            getContactUsEnquriesListState.list.map((row, index) => {
                tableData.push(
                    {
                        key: index,
                        name: row.name,
                        phone: row.phone,
                        email: row.email,
                        id: row._id,
                    }
                )
            })
            setTableData(tableData)
        }
    }, [getContactUsEnquriesListState])

    useEffect(() => {
        setRedirect([true, `/contact-us/list?page=${pagination.page}`])
    }, [pagination])


    return (
        <>
            {redirect[0] &&
                <Redirect to={redirect[1]} />}

            <Header
                title="Contact Us Dashboard"
              
            />
            <PageContainer  >


                {getContactUsEnquriesListState.apiState === "error" &&
                    <div style={{ height: 500, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} >
                    <p>{getContactUsEnquriesListState.message}</p>
                        <Button type="primary" onClick={() => setRefresh(refresh + 1)} >TRY AGAIN</Button>
                    </div>
                }

                {getContactUsEnquriesListState.apiState !== "error" &&
                    <>
                        <Xtable columns={columns} dataSource={tableData} pagination={false} scroll={{ x: 768, y: 600 }}
                        loading={getContactUsEnquriesListState.apiState === "loading"}
                        />
                        <Xpagination
                            pageSizeOptions={['25', '50', '100', '500']}
                            showSizeChanger
                        total={getContactUsEnquriesListState.pagination?.total_records}
                            onChange={(page, pageSize) => setPagination({ page: page, records: pageSize })}
                            current={pagination.page}
                            defaultPageSize={pagination.records}
                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                    />
                    <ContactUsView id={view.id} visible={view.visible} onClose={() => setView({ visible: false, id: null })} />

                    </>
                }
            </PageContainer>
        </>
    )
}

const mapStateToProps = (state) => ({
    getContactUsEnquriesListState: state.getContactUsEnquriesList
});

const mapDispatchToProps = (dispatch) => ({
    getContactUsEnquriesList: (params) => dispatch(getContactUsEnquriesList(params)),
    getContactUsEnquriesListReset: () => dispatch(getContactUsEnquriesListReset())
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactUslist);